















import { Vue, Component, Prop } from "@/shared/vuepack";
import AccountHolderBankAccountHolds from "./AccountHolderBankAccountHolds.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  components: {
    AccountHolderBankAccountHolds
  }
})
export default class AccountHolderManagement extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  username: string;

  @Prop()
  partnerId: number;

  warnBeforeRouteLeave = false;
  warnBeforeRouteLeaveMessage = "";

  get bankAccountHoldsVisible (): boolean {
    return this.custodianSettingsStore.displayBankAccountHolds;
  }

  mounted (): void {
    window.addEventListener("beforeunload", this.onBeforeUnload);
  }

  beforeDestroy () {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
  }

  onNavigationGuardChange (data: { confirmNavigation: boolean; message: string }) {
    this.warnBeforeRouteLeave = data.confirmNavigation;
    this.warnBeforeRouteLeaveMessage = data.message;
  }

  beforeRouteLeave (to, from, next) {
    if (this.warnBeforeRouteLeave) {
      const userWantsToLeave = window.confirm(this.warnBeforeRouteLeaveMessage);
      if (userWantsToLeave) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  onBeforeUnload (event: BeforeUnloadEvent) {
    if (!this.warnBeforeRouteLeave) {
      return;
    }

    // This won't show the custom warn message on modern browsers,
    // but it will activate the dialog with the browser default message
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event#browser_compatibility
    event.returnValue = this.warnBeforeRouteLeaveMessage;
  }
}
